
import React from 'react';
import StatsCard from '../card/StatsCard';
import { DollarSign, Zap, Server, Building2 } from 'lucide-react';

interface EnergyCardsProps {
  isEditMode: boolean;
}

const EnergyCards: React.FC<EnergyCardsProps> = ({ isEditMode }) => {
  return (
    <>
      <StatsCard
        id="energy-cost"
        title="Total Energy Cost"
        value="$2,200"
        change="18.8% vs last month"
        isIncreasing={true}
        icon={<DollarSign className="h-6 w-6 text-orange-600" />}
        bgClass="bg-orange-50 dark:bg-orange-900/20"
        delay={0}
        isEditMode={isEditMode}
      />
      
      <StatsCard
        id="energy-consumption"
        title="Energy Consumption"
        value="10,000 kWh"
        change="18.7% vs last month"
        isIncreasing={true}
        icon={<Zap className="h-6 w-6 text-amber-600" />}
        bgClass="bg-amber-50 dark:bg-amber-900/20"
        delay={100}
        isEditMode={isEditMode}
      />
      
      <StatsCard
        id="energy-devices"
        title="Energy Devices"
        value="132"
        change="5.6% vs last month"
        isIncreasing={true}
        icon={<Server className="h-6 w-6 text-orange-600" />}
        bgClass="bg-orange-50 dark:bg-orange-900/20"
        delay={200}
        isEditMode={isEditMode}
      />
      
      <StatsCard
        id="energy-cost-facility"
        title="Energy Cost/Facility"
        value="$220"
        change="18.9% vs last month"
        isIncreasing={true}
        icon={<Building2 className="h-6 w-6 text-orange-600" />}
        bgClass="bg-orange-50 dark:bg-orange-900/20"
        delay={300}
        isEditMode={isEditMode}
      />
    </>
  );
};

export default EnergyCards;
